/// <amd-module name="Tfs/Frame/Components/Help/UserSettingsService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { ExpandableContainer } from "VSSUI/Expandable";

export interface IUserSettingsMenu extends IVssService {
    expandUserSettingsMenu: () => void;
    setUserSettingsMenu: (expand: () => void) => void;
    expandHelpMenu: () => void;
    setHelpMenu: (expand: () => void) => void;
}

class UserSettingsMenu extends VssService implements IUserSettingsMenu {
    private expandUserSettings: () => void;
    private expandHelp: () => void;

    public expandUserSettingsMenu(): void {
        this.expandUserSettings();
    }

    public setUserSettingsMenu(expand: () => void): void {
        this.expandUserSettings = expand;
    }

    public expandHelpMenu(): void {
        this.expandHelp();
    }

    public setHelpMenu(expand: () => void): void {
        this.expandHelp = expand;
    }
}

Services.add("IUserSettingsMenu", { serviceFactory: UserSettingsMenu });
